import { jsx as _jsx } from "react/jsx-runtime";
export default function Layout({ children }) {
    return (_jsx("div", { style: { maxWidth: "1024px", minHeight: "100vh", background: "#000", color: "white", margin: "0 auto" }, children: _jsx("main", { children: children }) }));
}
